import React, { useEffect, Fragment } from 'react'
import { Alert } from 'antd'
import styles from './AlertBar.module.scss'
import { updateFirebaseToken } from 'api'
// import { identifierLocalStorage } from 'util/localstorage'

function AlertBar(props) {
  const textAlert = 'กรุณาเปิดการแจ้งเตือน Notification เพื่อให้แอปทำงานได้ดีขึ้น'
  const requestPermission = () => {
    if (('Notification' in window)) {
      window.Notification.requestPermission().then(function (permission) {
        // if (permission === 'granted') {
        //   updateFirebaseToken('click:alert')
        // } else {
        //   updateFirebaseToken('click:alert')
        // }
      })
    }
  }
  useEffect(() => {
    if (window.Notification?.permission) {
      window.localStorage.setItem('permission', window.Notification?.permission)
      const blockedNoti = () => (JSON.parse(localStorage.getItem('_fsbtk')) === 'messaging/permission-blocked')
      const closedNotication = () => (blockedNoti() || JSON.parse(localStorage.getItem('_fsbtk')) === '')
      const openPermission = () => (localStorage.getItem('permission') === 'granted')
      const blockPermission = () => (localStorage.getItem('permission') === 'denied')
      if (openPermission() && (!localStorage.getItem('_fsbtk') || JSON.parse(localStorage.getItem('_fsbtk')) === '')) {
        updateFirebaseToken()
      } else if (openPermission() && localStorage.getItem('_fsbtk') && closedNotication()) {
        updateFirebaseToken()
      } else if (openPermission() && localStorage.getItem('_fsbtk') && !blockedNoti()) {
        return
      } else if (blockPermission() && blockedNoti()) {
        return
      } else if (blockPermission() && !blockedNoti()) {
        updateFirebaseToken()
      }
    }
  }, [props])
  return (
    <Fragment>
      {
        window.Notification?.permission === 'denied' &&
        <div onClick={requestPermission}
          className={props?.pageInfo?.pageName === 'Testing' ? styles.rootAlertBarTesting : styles.rootAlertBar} >
          <Alert message={textAlert} type='warning' />
        </div>
      }
    </Fragment>

  )
}

export default AlertBar
